import React, {
  useRef,
  useState,
  useEffect,
  useMemo,
  useCallback,
} from "react";

import "../styles/HomeScreen.css";

import AddRole from "./AddRole";
import NoAuth from "./NoAuth";
import EnquiryList from "./EnquiryList";
import AddDepartment from "./AddDepartment";
import AddCategory from "./AddCategory";
import AddBank from "./AddBank";
import AddOffer from "./AddOffer";
import Sales from "./Sales";
import Manage from "./Manage";
import Profile from "./Profile";
import Enquiry from "./Enquiry";
import ModelBillings from "./inventory/ModelBillings";
import Master from "./Master";
import Employees from "./Employees";
import AreaAssignListList from "./AreaAssignListList";
import AddAssignArea from "./AddAssignArea";
import Work_Assign_Area from "./Master/Work Assign/Work_Assign_Area";
import { useSelector, useDispatch } from "react-redux";
import {
  clearCurrentUserData,
  clearProfileDataSliceState,
} from "../redux/slices/profileSlice";
import AddvsDelivery from "./AddvsDelivery";
import { clearUserListState } from "../redux/slices/getUserListSlice";
import { setShowMessage } from "../redux/slices/notificationSlice";
import { clearTokenBranchState } from "../redux/slices/tokenBranchChangeSlice";
import DealStages from "./DealStages";
import {
  useLocation,
  NavLink,
  useNavigate,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import EnquiryCategories from "./EnquiryCategories";
import Branch from "./Branch";
import State_list from "./Master/State/State_list";
import District_list from "./Master/District/District_list";
import Village_list from "./Master/Village/Village_list";
import Taluka_list from "./Master/Taluka/Taluka_list";
import Part_List from "./Master/Plan/Part_List";
import ServiceList from "./Master/ServiceList/ServiceList";
import BreadCrumb from "./BreadCrumb/BreadCrumb";
import Manufacturer_list from "./Master/Manufacturer/Manufacturer_list";
import Manufacturer_modal from "./Master/Manufacturer/Manufacturer_modal";
import Department_list from "./Master/Department/Department_list";
import Category_list from "./Master/Category/Category_list";
import Profile_list from "./Profile";
import Roles from "./Roles";
import Tax from "./Master/Tax/Tax";
import Variants from "./Master/Manufacturer/Sub_modal";
import Dashboard from "./Dashboard";
import UserProfile from "./UserProfile";
import Report from "./Report";
import Task from "./Task";
import UserTaskDetails from "./UserTaskDetails";
import axios from "axios";
import EnquirySources from "./Master/EnquirySources/EnquirySources";
import Holiday from "./Master/Holiday/Holiday";
import Message from "./Master/Message/Message";
import EnquirySources_model from "./Master/EnquirySources/EnquirySources_modal";
import WorkReport from "./WorkReport";
import WorkReportDetails from "./WorkReportDetails";
import translations from "../assets/locals/translations";
import MyLeave from "./MyLeave";
import MessagesList from "./Master/Message/MessagesList";
import dealStage from "../assets/images/deal.png";
import SendMessages from "./SendMessages";
import CustomField from "./Master/CoustoField/CustomField";
import CallReport from "./CallReport";
import CallReportInDetails from "./CallReportInDetails";
import TrackReport from "./TrackReport";
import ReportNotification from "./Master/notification/ReportNotification";
import LeadsBoard from "./Leads";
import EnquiryStage from "./report/enquiry/LostEnquiry";
import EmployeeForm from "./EmployeeForm";
import SalesData from "./sale/data/SalesData";
import { fetchFile } from "../utils/fetchFile";
import EditEnquiry from "./stages/EditEnquiry";
import EnquiryBoard from "./sale/enquiry/EnquiryBoard";
import AddData from "./sale/data/AddData";
import SalesReport from "./report/enquiry/SalesReport";
import TaskForm from "./TaskForm";
import TaskCompletionReport from "./TaskCompletionReport";
import ReportMenu from "./report/ReportMenu";
import TaskAnalyticsReport from "./TaskAnalyticsReport";
import TargetReport from "./report/TargetReport";
import Targets from "./Targets";
import RouteTrack from "./RouteTrack";
import ServicesMenu from "./servicing/ServicesMenu";
import AssociatedServices from "./servicing/AssociatedServices";
import AddRecordForm from "./inventory/AddRecordForm";
import ModelStock from "./inventory/ModelStock";
import ModelDepo from "./inventory/ModelDepo";
import ProductsList from "./Products";
import DeliveryProcess from "./delivery/DeliveryProcess";
import Login from "./Login";
import DeliveryStepsData from "./delivery/DeliveryStepsData";
import DeliveriesData from "./delivery/DeliveriesData";
import AdditionalRecordformWrapper from "./delivery/AdditionalForm";
import DeliveryForm from "./stages/DeliveryForm";
import AdditionalForm from "./delivery/AdditionalForm";
import ServicesDue from "./servicing/ServicesDue";
import EmployeeTrackingDashboard from "./tracking/EmployeeTrackingDashboard";
import AllServicesData from "./servicing/AllServicesData";
import ServiceItlCustomer from "./servicing/ServiceItlCustomer";
import TractorSoldOut from "./servicing/TractorSoldOut";
import Offers from "./Offers";
import EditDeliveryData from "./delivery/EditDeliveryData";

const CheckPermission = ({ children, path }) => {
  const rolesArray = localStorage.getItem("rolesArray");
  const checkList = rolesArray.split(",");
  console.log(checkList, "checklist---");
  console.log("checkList.includes(path)", checkList.includes(path));
  console.log("path", path);
  return checkList.includes(path) ? children : <NoAuth></NoAuth>;
};

export default function HomeScreen() {
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];
  const [profileUrl, setProfileUrl] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const bottomDiv = useRef();
  const adminAsideRef = useRef();
  const toggleBtnRef = useRef();
  const [bottomDivState, setBottomDivState] = useState(false);
  const [userPermissions, setUserPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentBranch, setCurrentBranch] = useState([]);
  const profileDataState = useSelector((state) => state.profileData.profile);
  const allState = useSelector((state) => state);
  const tokenBranchState = useSelector(
    (state) => state.tokenBranchChangeState.tokenBranchState
  );
  const ev_stage = location.state?.type || null;
  // normalize stage for menu navigation (fallback to NEW) — used by the Add Enquiry link
  const navEvStage = (ev_stage || "NEW").toString().toUpperCase();
  // normalized billing type for inventory menu (use 'add' by default)
  const navBillingType = (location.state?.type || "add").toString().toLowerCase();
  const [agencyData, setAgencyData] = useState({
    agencyUrl: null,
    agencyName: "Agency Name",
    manageTab: false,
    holidayTab: false,
  });

  const loadProfileImage = async (filename) => {
    const imageUrl = await fetchFile(filename);
    updateFavicon(imageUrl);
    setProfileUrl(imageUrl);
  };

  const updateFavicon = (url) => {
    const link = document.querySelector("link[rel~='icon']");
    if (!link) {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = url;
      document.head.appendChild(newLink);
    } else {
      link.href = url;
    }
  };

  useEffect(() => {
    const retrieveAgencyProfile = async () => {
      const url = `${process.env.REACT_APP_NODE_URL}/api/agency/get-agencybyid`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      setLoading(true);

      try {
        const response = await axios.get(url, config);
        const resultArray = response?.data?.result;

        if (resultArray && resultArray.length > 0) {
          // Map the array to an object using key_name
          const agencyProfile = resultArray.reduce((acc, curr) => {
            acc[curr.key_name] = curr.value;
            return acc;
          }, {});

          const agencyName = agencyProfile.name || "New Keshav Tractors";
          const agencyLogo = agencyProfile.logo;
          const manageTab =
            agencyProfile.sidebar_manage === "true" ||
            agencyProfile.sidebar_manage === "1";

          const holidayTab =
            agencyProfile.sidebar_holiday === "true" ||
            agencyProfile.sidebar_holiday === "1";


          setAgencyData({
            agencyName,
            agencyUrl: agencyLogo,
            manageTab: manageTab,
            holidayTab: holidayTab,
          });
          localStorage.setItem("sidebarManage", String(manageTab));
          localStorage.setItem("sidebarHoliday", String(holidayTab));

          document.title = agencyName || "CRM Pro";

          loadProfileImage(agencyLogo);
        } else {
          document.title = "New Keshav Tractors";
        }
      } catch (error) {
        console.error("Error retrieving agency profile:", error);
        document.title = "New Keshav Tractors";
      } finally {
        setLoading(false);
      }
    };

    retrieveAgencyProfile();
  }, []);

  useEffect(() => {
    if (tokenBranchState.isSuccess) {
      if (tokenBranchState.data.isSuccess) {
        localStorage.setItem("rbacToken", tokenBranchState.data.result);

        console.log("tokenBranchState &&&&&&&&&&&&&&", tokenBranchState);
        // dispatch(getProfileData(tokenBranchState.data.result))
        dispatch(clearTokenBranchState());
        console.log("please redirect to home");
        navigate("/home");

        window.location.reload();
      }
    }
  }, [tokenBranchState]);

  useEffect(() => {
    const collapse = document.getElementsByClassName("activeLink");
    if (collapse.length > 0) {
      collapse[0].parentElement.parentElement.parentElement.classList.add(
        "show"
      );
    }
  }, []);

  useEffect(() => {
    console.log(
      "profileDataState",
      profileDataState.currentUserData,
      "profile.........."
    );
    if (
      profileDataState.isSuccess &&
      profileDataState.currentUserData.isSuccess
    ) {
      const rolesArray = [];
      Array.from(profileDataState.currentUserData.result.features).filter(
        (i) => {
          rolesArray.push(i.feature);
        }
      );
      localStorage.setItem("rolesArray", rolesArray);
      localStorage.setItem(
        "userData",
        JSON.stringify(profileDataState.currentUserData.result)
      );
      dispatch(clearProfileDataSliceState());
      // navigate('/home')
    } else if (profileDataState.isError) {
      dispatch(setShowMessage("Server is temporarily unavailable"));
    }
  }, [profileDataState]);

  useEffect(() => {
    if (bottomDivState) {
      let handler = (event) => {
        if (!bottomDiv.current.contains(event.target)) {
          setBottomDivState(false);
        }
      };
      document.addEventListener("mousedown", handler);
      return () => {
        document.removeEventListener("mousedown", handler);
      };
    }
  }, [bottomDivState]);

  useEffect(() => {
    document.getElementsByTagName("body")[0].style.backgroundColor = "#edf1f4";
  }, []);

  const checkTabGrant = useCallback((pathAr) => {
    let success = false;
    const rolesArray = localStorage.getItem("rolesArray");
    const checkList = rolesArray.split(",");
    pathAr.forEach((element) => {
      if (checkList.includes(element)) {
        success = true;
      }
    });
    return success;
  }, []);

  function logout() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/login/logout`;

    axios.post(url, {}, {
      headers: {
        token: localStorage.getItem("rbacToken"),
      }
    })
      .then((response) => {
        if (response.data.success) {
          localStorage.clear();
          console.log("Logged out successfully");
        }
      })
      .catch((error) => {
        console.error("Error while logging out:", error);
      });

  }


  function logOutHandler() {
    logout();
    localStorage.clear();
    dispatch(clearUserListState());
    dispatch(clearProfileDataSliceState());
    dispatch(clearCurrentUserData());
    dispatch(clearCurrentUserData());
    dispatch(clearProfileDataSliceState());

    navigate("/login");
    <NavLink
      className={({ isActive }) => (isActive ? "activeLink" : "")}
      to="login"
    >
      {translations[currentLanguage].products}
    </NavLink>;
  }
  function getDateTime(time) {
    const data = new Date(time);
    const newDate = data.toDateString("DD-MM-YYYY");
    const newTime = data.toLocaleTimeString();
    return `${newDate} ${newTime}`;
  }

  function branchListChange(e) {
    let selectedBranchId = e.target.value;
    localStorage.setItem("currentBranchId", selectedBranchId);
    // dispatch(tokenBranchChangeDb(selectedBranchId));
  }
  function toggleHandler() {
    if (document.getElementById("root").classList.contains("toggleSideBar")) {
      document.getElementById("root").classList.remove("toggleSideBar");
    } else {
      document.getElementById("root").classList.add("toggleSideBar");
    }
  }
  const handleLogoClick = () => {
    navigate("/home/dashboard");
  };

  const openDashboard = () => {
    navigate("/home/dashboard");
  };
  useEffect(() => {
    let jsonData = localStorage.getItem("dealersList");
    let branchesList = JSON.parse(jsonData);
    // set here branchesList
    setCurrentBranch(branchesList);
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  const userRoleName = (
    profileDataState?.currentUserData?.result?.role || ""
  )
    .toString()
    .toLowerCase();
  const isSuperAdmin =
    !!profileDataState?.currentUserData?.result?.isSuperAdmin;
  const isAdminRole = userRoleName.includes("admin");
  const isManagerRole = userRoleName.includes("manager");
  const canSeeTargetsPage = isSuperAdmin || isAdminRole || isManagerRole;
  return (
    <>
      <aside ref={adminAsideRef} className="asideNav">
        <button
          onClick={toggleHandler}
          ref={toggleBtnRef}
          className="toggleBtn"
        >
          <main className="">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="headSvg bi bi-chevron-left"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
            </svg>
          </main>
        </button>
        <main className="asideMain">
          {/* site logo and name */}
          <div className="shadow rounded">
            <div className="logoSection">
              <img src={profileUrl} alt="Site Logo" className="siteLogo" />
              <h1 className="siteName">
                {agencyData.agencyName
                  ? agencyData.agencyName
                  : agencyData.agencyName === ""
                    ? "New keshav Tractors"
                    : "CRM Pro"}
              </h1>
            </div>
          </div>
          <section className="outerSection">
            <ul id="accordionExample" className="outUl">
              {checkTabGrant(["profile"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#home-collapseOne"
                    aria-expanded="false"
                    aria-controls="home-collapseOne"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="headSvg bi bi-house"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" />
                    </svg>
                    <span onClick={openDashboard}>
                      {translations[currentLanguage].home}
                    </span>
                  </button>
                  <div
                    id="home-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["dashboard"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="home/dashboard"
                          >
                            {translations[currentLanguage].dashboard}
                          </NavLink>
                        </li>
                      )}

                      {checkTabGrant(["user-profile"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="home/profiles/user"
                          >
                            {translations[currentLanguage].profile}
                          </NavLink>
                        </li>
                      )}

                      {checkTabGrant(["agency"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="home/profile/agency"
                          >
                            {translations[currentLanguage].agencyp}
                          </NavLink>
                        </li>
                      )}
                      {/* {
                        checkTabGrant(['profile']) && <li className='inLi'>
                          <NavLink className={({ isActive }) => isActive ? 'activeLink' : ''} to="enquiry" >
                            Enquiry
                          </NavLink>
                        </li>
                      } */}
                    </ul>
                  </div>
                </li>
              )}
              {checkTabGrant(["sales"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#sale-collapse"
                    aria-expanded="false"
                    aria-controls="sale-collapse"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-graph-up-arrow"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"
                      />
                    </svg>
                    <span>{translations[currentLanguage].sale}</span>
                  </button>
                  <div
                    id="sale-collapse"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["sales"]) && (
                        <li className="inLi">
                          <NavLink
                            end
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to={`/sale/enquiries/${navEvStage}/add`}
                            state={{ ev_stage: { type: navEvStage, value: 2 } }}
                          >
                            {translations[currentLanguage].addenq || "Add Enquiry"}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["sales"]) && (
                        <li className="inLi">
                          <NavLink
                            end
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="/sale/enquiries"
                          >
                            {translations[currentLanguage].enquiry}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["sales"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="sale/data"
                          >
                            {translations[currentLanguage].data || 'Data'}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["sales"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="sales/add"
                          >
                            {/* {translations[currentLanguage].enquiry} */}
                            {translations[currentLanguage].adddata || 'Add Data'}
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}

              {/* {checkTabGrant(["deal-stages"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#deal-collapse"
                    aria-expanded="false"
                    aria-controls="deal-collapse"
                  >
                    <img
                      src={dealStage}
                      alt="alt"
                      height={30}
                      width={25}
                      style={{ marginRight: "8px" }}
                    />
                    <span>{translations[currentLanguage].dealStages || 'Deal Stages'}</span>
                  </button>
                  <div
                    id="deal-collapse"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["leads"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="Leads/leadsboard"
                          >
                            Leads
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["deal-stages"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="DealStage/dealStages"
                          >
                            Deal Stages
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["deal-stages"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="DealStage/AddvsDelivery"
                          >
                            Add Inquiry v/s Delivery Report
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )} */}

              {checkTabGrant(["stock"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#stock-collapseOne"
                    aria-expanded="false"
                    aria-controls="stock-collapseOne"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      width="16"
                      height="16"
                    >
                      <path d="M3 13v-2l1-3 1-2h14l1 2 1 3v2h-1v4a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-1H9v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4H3zm2-4h14l-1-2H6l-1 2zm0 2v4h1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2h1v-4H5z" />
                    </svg>

                    <span>{translations[currentLanguage].inventory || 'Inventory'}</span>
                  </button>
                  <div
                    id="stock-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">

                      {checkTabGrant(["stock"]) && (
                        <li className="inLi">
                          <NavLink
                            end
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to={`/stock/billing/${navBillingType}`}
                            state={{ data: null, type: navBillingType }}
                          >
                            {translations[currentLanguage].addbilling || 'Add Billing'}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["stock"]) && (
                        <li className="inLi">
                          <NavLink
                            end
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="/stock/billing"
                          >
                            {translations[currentLanguage].billing || 'Billing'}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["stock"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="stocks"
                          >
                            {translations[currentLanguage].stocks || 'Stocks'}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["stock"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="depo"
                          >
                            {translations[currentLanguage].depo || 'Depo'}
                          </NavLink>
                        </li>
                      )}

                      {checkTabGrant(["stock"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="delivery/steps"
                          >
                            {translations[currentLanguage].pipeline || 'Pipeline'}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["stock"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="delivery/data"
                          >
                            {translations[currentLanguage].delivery || 'Delivery'}
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}

              {checkTabGrant(["service"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#service-collapseOne"
                    aria-expanded="false"
                    aria-controls="service-collapseOne"
                  >
                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="headSvg bi bi-house" viewBox="0 0 16 16">
                    <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" />
                  </svg> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-grid"
                      viewBox="0 0 16 16"
                    >
                      <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z" />
                    </svg>
                    <span>{translations[currentLanguage].service}</span>
                  </button>
                  <div
                    id="service-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["service"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="service/delivery"
                          >
                            {translations[currentLanguage].delivery || 'Delivery'}
                          </NavLink>
                        </li>
                      )}

                      {checkTabGrant(["service"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="service/itl-customer"
                          >
                            {translations[currentLanguage].itlcustomer || "ITL Customer"}
                          </NavLink>
                        </li>
                      )}

                      {checkTabGrant(["service"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="service/servicing"
                          >
                            {translations[currentLanguage].servicing || 'Servicing'}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["products"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="/service/due"
                          >
                            {translations[currentLanguage].servicesdue || 'Services Due'}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["products"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="/service/sold"
                          >
                            {translations[currentLanguage].soldout || 'Sold Out'}
                          </NavLink>
                        </li>
                      )}
                      {/* {checkTabGrant(["products"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="/service/products"
                          >
                            {translations[currentLanguage].products}
                          </NavLink>
                        </li>
                      )} */}

                      {/* {checkTabGrant(["sales"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="/service/sales"
                          >
                            {translations[currentLanguage].sales}
                          </NavLink>
                        </li>
                      )} */}
                    </ul>
                  </div>
                </li>
              )}
              {checkTabGrant(["manage"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#manage-collapseOne"
                    aria-expanded="false"
                    aria-controls="manage-collapseOne"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-diagram-3-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"
                      />
                    </svg>
                    <span> {translations[currentLanguage].management}</span>
                  </button>
                  <div
                    id="manage-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {agencyData.manageTab && checkTabGrant(["manage"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="management/manage"
                          >
                            {translations[currentLanguage].manage}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["task"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="management/mytask"
                          >
                            {translations[currentLanguage].mytask}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["task"]) && canSeeTargetsPage && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="management/targets"
                          >
                            {translations[currentLanguage].customtargets ||
                              translations[currentLanguage].targets ||
                              "Targets"}
                          </NavLink>
                        </li>
                      )}
                      {checkTabGrant(["task"]) && canSeeTargetsPage && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="management/route-track"
                          >
                            {t.routetracking || "Route Tracking"}
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}
              {checkTabGrant(["report"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#reports-collapseOne"
                    aria-expanded="false"
                    aria-controls="reports-collapseOne"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                      width="24"
                      height="24"
                    >
                      <path d="M4 0h6l4 4v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm6 1.5V5h3.5L10 1.5zM3 2v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6h-4V2H4a1 1 0 0 0-1 1z" />
                    </svg>
                    <span>{translations[currentLanguage].reports || 'Reports'}</span>
                  </button>
                  <div
                    id="reports-collapseOne"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["report"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="reports"
                          >
                            {translations[currentLanguage].allreports || 'All Reports'}
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )}
              {checkTabGrant([
                // "roles",
                // "add-role",
                // "add-user",
                // "edit-user",
                // "users",
                "configuration",
                "roles",
                "employee",
                "add-employee",
                "edit-employee",
              ]) && (
                  <li className="outLi">
                    <button
                      className="headBtn"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#admin-collapseOne"
                      aria-expanded="false"
                      aria-controls="admin-collapseOne"
                    >
                      {/* <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="headSvg bi bi-house" viewBox="0 0 16 16">
                    <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" />
                  </svg> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        className="bi bi-person-gear"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
                      </svg>
                      <span>{translations[currentLanguage].administration}</span>
                    </button>
                    <div
                      id="admin-collapseOne"
                      data-bs-parent="#accordionExample"
                      className="accordion-collapse collapse"
                    >
                      <ul className="inUl">
                        {checkTabGrant(["roles"]) && (
                          <li className="inLi">
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? "activeLink" : ""
                              }
                              to="administration/roles"
                            >
                              {translations[currentLanguage].roles}
                            </NavLink>
                          </li>
                        )}
                        {/* {profileDataState?.currentUserData?.result?.isSuperAdmin &&
                          checkTabGrant(["users"]) && (
                            <li className="inLi">
                              <NavLink
                                className={({ isActive }) =>
                                  isActive ? "activeLink" : ""
                                }
                                to="administration/users"
                              >
                                {translations[currentLanguage].users}
                              </NavLink>
                            </li>
                          )
                        } */}
                        {checkTabGrant(["employee"]) && (
                          <li className="inLi">
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? "activeLink" : ""
                              }
                              to="administration/employees"
                            >
                              {translations[currentLanguage].employee}
                            </NavLink>
                          </li>
                        )}
                        {checkTabGrant(["configuration"]) && (
                          <li className="inLi">
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? "activeLink" : ""
                              }
                              to="administration/configuration"
                            >
                              {translations[currentLanguage].configuration}
                            </NavLink>
                          </li>
                        )}
                        {/* {checkTabGrant(["report"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="administration/report"
                          >
                            {translations[currentLanguage].report}
                          </NavLink>
                        </li>
                      )} */}

                        {/*need to remove this */}
                        {/* {
                        checkTabGrant(['users']) && <li className='inLi'>
                          <NavLink className={({ isActive }) => isActive ? 'activeLink' : ''} to="administration/enquirycategories" >
                            Enquiry categories
                          </NavLink>
                        </li>
                      } */}
                        {/* {checkTabGrant(["branch"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="administration/branch"
                          >
                            Branch
                          </NavLink>
                        </li>
                      )} */}
                      </ul>
                    </div>
                  </li>
                )}

              {/* {checkTabGrant(["profile"]) && (
                <li className="outLi">
                  <button
                    className="headBtn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#master-collapse"
                    aria-expanded="false"
                    aria-controls="master-collapse"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-pencil-square"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                      <path
                        fill-rule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                      />
                    </svg>
                    <span>{translations[currentLanguage].configuration || 'Configuration'}</span>
                  </button>
                  <div
                    id="master-collapse"
                    data-bs-parent="#accordionExample"
                    className="accordion-collapse collapse"
                  >
                    <ul className="inUl">
                      {checkTabGrant(["profile"]) && (
                        <li className="inLi">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "activeLink" : ""
                            }
                            to="configuration"
                          >
                            Configuration
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </li>
              )} */}
            </ul>
          </section>
          <div className="mb-3">
            <section className="profileSection outerSection">
              <div
                onClick={() => {
                  bottomDivState
                    ? setBottomDivState(false)
                    : setBottomDivState(true);
                }}
                id="asideProfilTab"
                type="button"
                className="d-flex flex-row"
              >
                <div className="myTextContainer">
                  <span className="text-uppercase">
                    {profileDataState?.currentUserData?.result?.first_name
                      ? `${profileDataState.currentUserData.result.first_name.slice(0, 1)}`
                      : "A"}
                  </span>
                </div>
                <div className="userNameDis ps-2 d-flex align-items-center ">
                  <h6 className="m-0 text-uppercase text-white">
                    {Object.keys(profileDataState.currentUserData).length
                      ? `${profileDataState?.currentUserData.result.first_name} ${profileDataState?.currentUserData.result.last_name}`
                      : "User"}
                  </h6>
                </div>
              </div>
              {bottomDivState && (
                <div ref={bottomDiv} className="logoutSideBar">
                  <div className="d-flex justify-content-between">
                    <h6 className="text-white">
                      {t.emailcolon || 'Email :'} {" "}
                      {Object.keys(profileDataState.currentUserData).length >
                        0 &&
                        `${profileDataState?.currentUserData.result.email}`}
                    </h6>
                    <button
                      onClick={() => {
                        setBottomDivState(false);
                      }}
                      className="svgBtn"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        fill="currentColor"
                        className="bi bi-x-lg"
                        viewBox="0 0 16 16"
                      >
                        gg
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                      </svg>
                    </button>
                  </div>
                  <h6 className="text-white mt-2">
                    {t.currentbranch || 'Current branch :'}
                    <select
                      defaultValue={localStorage.getItem("currentBranchId")}
                      onChange={branchListChange}
                      className="mt-2 mySelectBox"
                      name=""
                      id=""
                    >
                      {currentBranch &&
                        currentBranch.length > 0 &&
                        currentBranch.map((branch, index) => {
                          return (
                            <option
                              className="branch-text-list"
                              key={index}
                              value={branch.id}
                            >
                              {branch.name}
                            </option>
                          );
                        })}
                    </select>
                  </h6>
                  <div className="mt-3 d-flex flex-column">
                    <div className="d-flex flex-wrap align-items-center border-bottom pb-2">
                      <div className="myTextContainer">
                        <span className="text-uppercase">
                          {Object.keys(profileDataState.currentUserData)
                            .length > 0 &&
                          profileDataState?.currentUserData?.result?.first_name
                            ? `${profileDataState.currentUserData.result.first_name.slice(0, 1)}`
                            : "A"}
                        </span>
                      </div>
                      <span className="pt-2 ps-2 text-white myH7">
                        {t.lastlogin || 'Last login :'}{" "}
                        {Object.keys(profileDataState.currentUserData).length >
                          0 &&
                          profileDataState?.currentUserData.result.last_login !=
                          null
                          ? getDateTime(
                            profileDataState?.currentUserData.result
                              .last_login
                          )
                          : t.firsttimelogin || "first time logged in"}
                      </span>
                    </div>
                    <div className="mt-3 d-flex justify-content-end">
                      <button
                        className="myBtn py-1 px-3"
                        onClick={logOutHandler}
                        href=""
                      >
                        {translations[currentLanguage].logout}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>
        </main>
      </aside>

      <main id="mainContainer">
        <BreadCrumb />
        <div className="container-fluid">
          <Routes>
            <Route path="no-access" element={<NoAuth />} exact />

            <Route
              path="/home/dashboard"
              element={
                <CheckPermission path="dashboard">
                  <Dashboard />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/home/profiles/user"
              element={
                <CheckPermission path="user-profile">
                  <UserProfile />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/profile"
              element={
                <CheckPermission path="agency">
                  <Profile />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/enquiry"
              element={
                <CheckPermission path="enquiry">
                  <Enquiry />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sale/inquiries/enquiry"
              element={
                <CheckPermission path="enquiry">
                  <Enquiry workFor="Enquiry" />
                </CheckPermission>
              }
              exact
            />

            <Route
              path="/sale/inquiries/editenquiry"
              element={
                <CheckPermission path="enquiry">
                  <Enquiry workFor="editEnquiry" />
                </CheckPermission>
              }
              exact
            />

            <Route
              path="/sale/inquiries/newenquiry"
              element={
                <CheckPermission path="enquiry">
                  <Enquiry workFor="newEnquiry" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sale/inquiries"
              element={
                <CheckPermission path="enquiry">
                  <EnquiryList />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sale/enquiries"
              element={
                <CheckPermission path="enquiry">
                  <EnquiryBoard />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sale/enquiries/:type"
              element={
                <CheckPermission path="enquiry">
                  <EnquiryList />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sale/enquiries/:type/edit"
              element={
                <CheckPermission path="enquiry">
                  <EditEnquiry />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sale/enquiries/:type/add"
              element={
                <CheckPermission path="enquiry">
                  <EditEnquiry />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sale/data"
              element={
                <CheckPermission path="enquiry">
                  <SalesData />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sales/add"
              element={
                <CheckPermission path="enquiry">
                  <AddData />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sale/area-Assign"
              element={<AreaAssignListList />}
              exact
            />
            <Route
              path="/sale/area-Assign/add-AsignArea"
              element={
                <CheckPermission path="enquiry">
                  <AddAssignArea />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sale/inquiries/sendmessages"
              element={
                <CheckPermission path="enquiry">
                  <SendMessages />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/DealStage/dealStages"
              element={
                <CheckPermission path="deal-stages">
                  <DealStages />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/DealStage/AddvsDelivery"
              element={
                <CheckPermission path="deal-stages">
                  <AddvsDelivery />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/Leads/leadsboard"
              element={
                <CheckPermission path="deal-stages">
                  <LeadsBoard />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration"
              element={
                <CheckPermission path="profile">
                  <Master />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/state"
              element={
                <CheckPermission path="profile">
                  <State_list />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/district"
              element={
                <CheckPermission path="profile">
                  <District_list />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/village"
              element={
                <CheckPermission path="profile">
                  <Village_list />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/taluka"
              element={
                <CheckPermission path="profile">
                  <Taluka_list />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/partlist"
              element={
                <CheckPermission path="profile">
                  <Part_List />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/servicelist"
              element={
                <CheckPermission path="profile">
                  <ServiceList />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/notification"
              element={
                <CheckPermission path="profile">
                  <ReportNotification />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/department"
              element={
                <CheckPermission path="profile">
                  <Department_list workFor="department" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/department/add"
              element={
                <CheckPermission path="profile">
                  <AddDepartment workFor="forAdd" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/department/edit"
              element={
                <CheckPermission path="profile">
                  <AddDepartment workFor="forEdit" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/manufacturer"
              element={
                <CheckPermission path="profile">
                  <Manufacturer_list />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="//administration/configuration/manufacture/modal"
              element={
                <CheckPermission path="profile">
                  <Manufacturer_modal />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/manufacture/modal"
              element={
                <CheckPermission path="profile">
                  <Manufacturer_modal />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/manufacture/modal/variants"
              element={
                <CheckPermission path="profile">
                  <Variants />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/enquirysources"
              element={
                <CheckPermission path="profile">
                  <EnquirySources workFor="forAddd" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/holiday"
              element={
                <CheckPermission path="profile">
                  <Holiday />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/messagelist"
              element={
                <CheckPermission path="profile">
                  <MessagesList />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/customfield"
              element={
                <CheckPermission path="profile">
                  <CustomField />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/MessagesList/Message"
              element={
                <CheckPermission path="profile">
                  <Message workFor="addMsg" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/MessagesList/edit"
              element={
                <CheckPermission path="profile">
                  <Message workFor="editMsg" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/enquirysourcesmodel"
              element={
                <CheckPermission path="profile">
                  <EnquirySources_model />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/tax"
              element={
                <CheckPermission path="profile">
                  <Tax />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/report"
              element={
                <CheckPermission path="report">
                  <Report />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/report/totalenquiry"
              element={
                <CheckPermission path="report">
                  <SalesReport />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/sale/data/:type"
              element={
                <CheckPermission path="enquiry">
                  <EnquiryStage />
                </CheckPermission>
              }
              exact
            />

            <Route
              path="/sale/data/:type/edit"
              element={
                <CheckPermission path="enquiry">
                  <EditEnquiry />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/report/WorkAssignArea"
              element={
                <CheckPermission path="report">
                  <Work_Assign_Area />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/report/workreport"
              element={
                <CheckPermission path="report">
                  <WorkReport />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/report/callreport"
              element={
                <CheckPermission path="report">
                  <CallReport />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/report/callreport/incompletecalldetails"
              element={
                <CheckPermission path="report">
                  <CallReportInDetails />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/report/trackreport"
              element={
                <CheckPermission path="report">
                  <TrackReport />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/report/workreport/details"
              element={
                <CheckPermission path="report">
                  <WorkReportDetails />
                </CheckPermission>
              }
              exact
            />

            {/* <Route
              path="/service/sales"
              element={
                <CheckPermission path="sales">
                  <Sales />
                </CheckPermission>
              }
              exact
            /> */}

            <Route
              path="/management/manage"
              element={
                <CheckPermission path="manage">
                  <Manage />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/reports"
              element={
                <CheckPermission path="report">
                  <ReportMenu />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/reports/task/analytics"
              element={
                <CheckPermission path="report">
                  <TaskAnalyticsReport />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/reports/targets/:view?"
              element={
                <CheckPermission path="report">
                  <TargetReport />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/management/targets"
              element={
                <CheckPermission path="manage">
                  {canSeeTargetsPage ? <Targets /> : <NoAuth />}
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/management/route-track"
              element={
                <CheckPermission path="manage">
                  {canSeeTargetsPage ? <RouteTrack /> : <NoAuth />}
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/management/manage/myleave"
              element={
                <CheckPermission path="manage">
                  <MyLeave />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/management/mytask"
              element={
                <CheckPermission path="manage">
                  <Task />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/login"
              element={
                <CheckPermission path="login">
                  <Login />
                </CheckPermission>
              }
              exact
            />

            <Route
              path="/management/mytask/task-detail"
              element={
                <CheckPermission path="manage">
                  <UserTaskDetails />
                </CheckPermission>
              }
              exact
            />

            <Route
              path="/administration/*"
              element={<Navigate to="/administration/configuration" />}
              exact
            />
            <Route
              path="/administration/roles"
              element={
                <CheckPermission path="roles">
                  <Roles workFor="roles" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/roles/add"
              element={
                <CheckPermission path="add-role">
                  <AddRole workFor="addRole" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/roles/edit"
              element={
                <CheckPermission path="add-role">
                  <AddRole workFor="forEdit" />
                </CheckPermission>
              }
              exact
            />

            {/* <Route
              path="administration/users"
              element={
                <CheckPermission path="users">
                  <Users />
                </CheckPermission>
              }
              exact
            /> */}

            <Route
              path="/administration/employees"
              element={
                <CheckPermission path="employee">
                  <Employees />
                </CheckPermission>
              }
              exact
            />
            {/* <Route
              path="administration/users/add"
              element={
                <CheckPermission path="add-user">
                  <AddUser workFor="forAdd" />
                </CheckPermission>
              }
              exact
            /> */}
            {/* <Route
              path="administration/employees/add"
              element={
                // <CheckPermission path="add-employee">
                <AddEmployee workFor="forAdd" />
                // </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/employees/edit"
              element={
                // <CheckPermission path="add-role">
                <AddEmployee workFor="forEdit" />
                // </CheckPermission>
              }
              exact
            /> */}

            <Route
              path="/administration/employees/add"
              element={
                <CheckPermission path="add-employee">
                  <EmployeeForm workFor="Add" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/employees/edit"
              element={
                <CheckPermission path="edit-employee">
                  <EmployeeForm workFor="Edit" />
                </CheckPermission>
              }
              exact
            />

            <Route
              path="/administration/enquirycategories"
              element={
                <CheckPermission path="category">
                  <EnquiryCategories />
                </CheckPermission>
              }
              exact
            />

            <Route
              path="/administration/configuration/category"
              element={
                <CheckPermission path="category">
                  <Category_list workFor="category" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/category/add"
              element={
                <CheckPermission path="category">
                  <AddCategory workFor="forAdd" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/category/edit"
              element={
                <CheckPermission path="category">
                  <AddCategory workFor="forEdit" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/branch"
              element={
                <CheckPermission path="branch">
                  <Branch workFor="branch" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/branch/add"
              element={
                <CheckPermission path="branch">
                  <Branch workFor="addBranch" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/branch/edit"
              element={
                <CheckPermission path="branch">
                  <Branch workFor="editBranch" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/task"
              element={
                <CheckPermission path="task">
                  <Task workFor="Task" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/task/report"
              element={
                <CheckPermission path="task">
                  <TaskCompletionReport />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/task/:type"
              element={
                <CheckPermission path="task">
                  <TaskForm />
                </CheckPermission>
              }
              exact
            />
            {/* <Route
              path="administration/configuration/Task/edit"
              element={
                <CheckPermission path="task">
                  <AssignTask workFor="editTask" />
                </CheckPermission>
              }
              exact
            /> */}

            <Route
              path="/home/profile/agency"
              element={
                <CheckPermission path="agency">
                  <Profile_list workFor="forEdit" />
                </CheckPermission>
              }
              exact
            />

            {/*<Route
              path="administration/configuration/agency"
              element={
                <CheckPermission path="agency">
                  <Agency_list workFor="agency" />
                </CheckPermission>
              }
              exact
            /> */}

            {/* <Route
              path="administration/configuration/addagency"
              element={
                <CheckPermission path="profile">
                  <AddAgency workFor="forAdd" />
                </CheckPermission>
              }
              exact
            /> */}

            <Route
              path="/administration/configuration/agency"
              element={
                <CheckPermission path="agency">
                  <Profile_list workFor="forAdd" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/addbank"
              element={
                <CheckPermission path="profile">
                  <AddBank workFor="forAdd" />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/offer"
              element={
                <CheckPermission path="profile">
                  <Offers />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/administration/configuration/offer/:type"
              element={
                <CheckPermission path="profile">
                  <AddOffer />
                </CheckPermission>
              }
              exact
            />

            {/* <Route path='admin'>
          </Route> */}
            <Route
              path="/stocks"
              element={
                <CheckPermission path="stock">
                  <ModelStock />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/depo"
              element={
                <CheckPermission path="stock">
                  <ModelDepo />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/stocks/delivery/add"
              element={
                <CheckPermission path="stock">
                  <DeliveryForm />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/depo/delivery/add"
              element={
                <CheckPermission path="stock">
                  <DeliveryForm />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/stock/billing"
              element={
                <CheckPermission path="stock">
                  <ModelBillings />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/delivery/data"
              element={
                <CheckPermission path="stock">
                  <DeliveriesData />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/delivery/data/edit"
              element={
                <CheckPermission path="stock">
                  <EditDeliveryData />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/delivery/data/add"
              element={
                <CheckPermission path="stock">
                  <AdditionalRecordformWrapper />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/delivery/steps"
              element={
                <CheckPermission path="stock">
                  <DeliveryProcess />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/delivery/steps/:type"
              element={
                <CheckPermission path="stock">
                  <DeliveryStepsData />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/delivery/steps/finalization/edit"
              element={
                <CheckPermission path="stock">
                  <AdditionalForm />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/stock/billing/steps"
              element={
                <CheckPermission path="stock">
                  <DeliveryProcess />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/stock/billing/:type"
              element={
                <CheckPermission path="stock">
                  <AddRecordForm />
                </CheckPermission>
              }
              exact
            />

            <Route
              path="/service/servicing"
              element={
                <CheckPermission path="service">
                  <ServicesMenu />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/service/due"
              element={
                <CheckPermission path="service">
                  <ServicesDue />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/service/sold"
              element={
                <CheckPermission path="service">
                  <TractorSoldOut />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/service/servicing/:type"
              element={
                <CheckPermission path="service">
                  <AssociatedServices />
                </CheckPermission>
              }
              exact
            />
            {/* <Route
              path="/service/products"
              element={
                <CheckPermission path="service">
                  <ProductsList />
                </CheckPermission>
              }
              exact
            /> */}
            <Route
              path="/tracking/live-map"
              element={
                <CheckPermission path="service">
                  <EmployeeTrackingDashboard />
                </CheckPermission>
              }
              exact
            />
            <Route
              path="/service/delivery"
              element={
                <CheckPermission path="service">
                  <AllServicesData />
                </CheckPermission>
              }
              exact
            />

            <Route
              path="/service/itl-customer"
              element={
                <CheckPermission path="service">
                  <ServiceItlCustomer />
                </CheckPermission>
              }
              exact
            />

            <Route path="/login" element={<Login />} exact />

            <Route path="*" element={<Navigate to="/home/dashboard" />} />
          </Routes>
        </div>
      </main>
    </>
  );
}
